"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceQueueStrategyEnum = exports.QueueStrategyEnum = void 0;
var QueueStrategyEnum;
(function (QueueStrategyEnum) {
    QueueStrategyEnum["RoundRoundRobin"] = "round_round_robin";
    QueueStrategyEnum["Random"] = "random";
    QueueStrategyEnum["SkillBaseAgentsReady"] = "skill_based_agents_ready";
    QueueStrategyEnum["SkillBasedTimeout"] = "skill_based_timeout";
})(QueueStrategyEnum = exports.QueueStrategyEnum || (exports.QueueStrategyEnum = {}));
var VoiceQueueStrategyEnum;
(function (VoiceQueueStrategyEnum) {
    VoiceQueueStrategyEnum["RingAll"] = "ringall";
    VoiceQueueStrategyEnum["RoundRobin"] = "roundrobin";
    VoiceQueueStrategyEnum["LeastRecent"] = "leastrecent";
    VoiceQueueStrategyEnum["FewestCalls"] = "fewestcalls";
    VoiceQueueStrategyEnum["RRMemory"] = "rrmemory";
    VoiceQueueStrategyEnum["Linear"] = "linear";
    VoiceQueueStrategyEnum["WRandom"] = "wrandom";
})(VoiceQueueStrategyEnum = exports.VoiceQueueStrategyEnum || (exports.VoiceQueueStrategyEnum = {}));
